<template>
    <div class="home">


        <!-- <pageheader :text="heading"/> -->


        <b-row>

            <b-col md="8">

                <h1 class="mb-3">{{heading}}</h1>

                <div class="quickactions" v-if="user && !user.blocked">
                    <b-button size="lg" variant="secondary" @click="sendToGame()" v-show="game">Gå til spillehall</b-button>

                    <b-button size="lg" variant="secondary" to="/overforing">Sett inn penger</b-button>

                    <b-button size="lg" variant="secondary" to="/min-side">Min side</b-button>
                </div>

                <b-alert show variant="danger" v-if="user && user.blocked">
                    <h4 class="alert-heading">Blokkering</h4>
                    <p>
                        Du har blokkert deg for spill og kan derfor ikke spille.
                    </p>
                </b-alert>


                <b-alert show v-for="n in notifications" :key="n.id" :variant="n.type">
                    <h4 class="alert-heading">{{n.title}}</h4>
                    <p>
                        {{n.content}}
                    </p>
                </b-alert>

                <b-alert show variant="success" v-if="newUser">
                    <h4 class="alert-heading">Velkommen!</h4>
                    <p>
                        Velkommen til ditt panel hos Norskbingo! <strong>Din kort-id er: {{user.cardId}}</strong>
                    </p>
                </b-alert>

                <b-alert show>
                    <h4 class="alert-heading">Utbetaling</h4>
                    <p>
                        Vi har nå lansert automatisk utbetalingsløsning! <router-link to="/utbetaling">Gå til utbetaling</router-link>
                    </p>
                </b-alert>

            </b-col>

            <b-col md="4" class="infoRow">

                <h2 class="mb-3">Informasjon</h2>

                <b-card class="mb-4">
                    <b-card-text v-if="user">
                        Saldo: {{user.balance}},-<br>
                        Poeng: {{user.points}}<br>
                        Kort-ID: {{user.cardId}}<br>
                        <router-link to="/min-side">Min side</router-link>
                    </b-card-text>
                </b-card>

                <b-card >
                    <b-card-text v-if="user">
                        <strong>{{user.hall.name}}</strong><br>
                        {{user.hall.owner.name}}<br>
                        ({{user.hall.owner.orgnum}})<br>
                        {{user.hall.owner.email}}<br>
                        {{user.hall.owner.phone}}<br>
                        {{user.hall.owner.address}}<br>
                        {{user.hall.owner.zip}} {{user.hall.owner.city}}<br>
                    </b-card-text>
                </b-card>

            </b-col>

        </b-row>




        <div v-html="gameFormContent">
        </div>


    </div>
</template>

<script>
// @ is an alias to /src


export default {
    name: 'Home',
    components: {

    },
    data() {
        return {
            user: null,
            notifications: null,
            game: null,
            gameFormContent: ''
        }
    },
    mounted() {

        // Get user data
        this.$api.get(`/users/${this.$store.getUser().card_id}/`)
        .then((response) => {
            // Fill form
            this.user = response.data.data
        })
        .catch((response) => {
            console.log(response);
        });


        // Get first game
        this.$api.get(`/users/${this.$store.getUser().card_id}/games/`)
        .then((response) => {
            let games = response.data.data;

            this.game = games.length ? games[0] : false;
        })
        .catch((response) => {
            console.log(response);
        });


        // Get notifications
        this.$api.get(`/users/${this.$store.getUser().card_id}/notifications/`)
        .then((response) => {
            // Fill form
            this.notifications = response.data.data
        })
        .catch((response) => {
            console.log(response);
        });


    },
    methods: {
        sendToGame() {

            this.$api.get(`/users/${this.$store.getUser().card_id}/games/${this.game.port}/`)
            .then((response) => {

                this.gameFormContent = response.data

                setTimeout(function () {
                    let form = document.querySelector("form[name='form']");

                    form.submit();
                }.bind(this), 50)

            })
            .catch((response) => {
                console.log(response);
            });

        }
    },
    computed: {
        heading:  function() {
            if (this.user)return "Velkommen "+this.user.name+"!"
            else return "Velkommen";
        },
        newUser: function() {
            if (!this.user) return false;

            let now = new Date();

            let firstWeek = new Date(Date.parse(this.user.registred_at));
            firstWeek.setDate(firstWeek.getDate() + 7);

            return firstWeek >= now;
        }
    }
}
</script>


<style lang="scss">
h1 {
    font-size: 2rem;
}
.quickactions {
    margin-bottom: 2em;
}
.quickactions .btn{
    margin-top:0.5em;
    margin-right: 1em;
}


@media only screen and (max-width: 576px) {
    .infoRow {
        margin-top: 2em;
    }

    h2 {
        font-size: 1.5em;
    }
}


</style>
